module.exports = __webpack_public_path__ + "a440bfd281623576bec82d692860bb70.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/korolev_bold-webfont.woff
// module id = Q5WN
// module chunks = 0